import * as React from 'react';
import { Link } from '../router';

interface Props extends React.HTMLProps<HTMLAnchorElement> {
  isSelected?: boolean;
}

const Button: React.SFC<Props> = (props: Props) => {
  const linkProps = {
    ...props
  }
  delete (linkProps.isSelected)
  let bgStyle
  if (props.isSelected) {
    bgStyle = { backgroundColor: '#96d7da' }
  }
  return (
    <Link
      {...linkProps}
      styleNormal={{
        ...linkButton,
        ...bgStyle,
        ...props.style
      }}
      styleOver={{
        ...linkButtonHover,
        ...props.style,
        backgroundColor: (props.style && props.style.backgroundColor) || linkButtonHover.backgroundColor
      }}
      ref={() => null}
    />
  );
}

const linkButton: React.CSSProperties = {
  fontSize: '85%',
  height: 44,
  boxSizing: 'border-box',
  backgroundColor: '#EEE',
  textDecoration: 'none',
  color: 'black',
  borderRadius: 5,
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: 10,
  paddingRight: 10
}

const linkButtonHover: React.CSSProperties = {
  ...linkButton,
  backgroundColor: '#96d7da'
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.tsx